export default __webpack_public_path__ + "static/media/cross-grey.606b4ec8.svg";